<template>
  <div class="foot_page">
    <div class="top_box" v-if="resultData.txt">
      <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click="$store.commit('setAudioPlay',false)"
        alt
      >
      <img
        src="@/assets/img/audio_close.png"
        @click="$store.commit('setAudioPlay',true)"
        v-else
        class="contro_audio right"
        alt
      >
      <!-- <div class="w100 fle_no">
        <img src="@/assets/img/com_txt.png" class="logo_txt" alt>
      </div>-->
      <!-- <div class="top_txt fle_no">人格关键词</div> -->
      <div class="w100 fle_no">
        <!-- <img :src="resultData.txt" class="result_txt" alt> -->
        <img :src="resultData.img" style="padding-left:4%" class="w100" alt>
      </div>
      <div class="w100 dis_f ali_ct jus_bt btn_box fle_no">
        <img
          src="@/assets/img/online_shop.png"
          @click="openOnline"
          data-name="线上商城"
          class="result_btn"
          alt
        >
        <img
          src="@/assets/img/shop_btn.png"
          @click="showList=true"
          data-name="线下门店"
          class="result_btn"
          alt
        >
      </div>
      <img src="@/assets/img/share_txt.png" class="share_img fle_no" alt>
      <!-- 展示门店列表 -->
      <div class="b_box dis_f fle_f fle_no" v-if="showList" @click="showList=false">
        <div class="shop_box dis_f fle_t" @click.stop>
          <div class="shop_title fle_no">Ole/blt 实体店定位</div>
          <div class="fl1 w100" style="overflow-y: auto;">
            <div
              @click="showMap(item)"
              class="shop_list txo"
              v-for="item in shopList"
              :key="item.id"
            >{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { constants } from "crypto";
export default {
  data() {
    return {
      shopList: [],
      showList: false,
      resultData: {}
    };
  },
  computed: {
    ...mapState(["testData"])
  },
  created() {
    sessionStorage.setItem("sl", JSON.stringify(this.testData));
    const matchingArr = {
      a: [[0, 1, 0], [0, 2, 0], [2, 1, 1], [2, 0, 2]],
      b: [[0, 1, 1], [2, 2, 1], [0, 0, 3], [1, 1, 3]],
      c: [[2, 2, 2], [1, 0, 2], [0, 1, 3], [2, 2, 3]],
      d: [[2, 0, 1], [2, 1, 0], [1, 2, 1], [0, 2, 3]],
      e: [[0, 0, 0], [1, 1, 0], [0, 1, 2], [2, 1, 2]],
      f: [[1, 0, 0], [0, 0, 1], [1, 1, 2], [0, 2, 2]],
      g: [[2, 0, 0], [1, 0, 1], [2, 1, 3], [1, 2, 3]],
      h: [[2, 2, 0], [0, 2, 1], [0, 0, 2], [2, 0, 3]],
      i: [[1, 2, 0], [1, 1, 1], [1, 2, 2], [1, 0, 3]]
    }; //匹配 规则
    const resultList = {};
    for (let i in matchingArr) {
      matchingArr[i] = matchingArr[i].map(item => item.toString());
    }
    let testData = JSON.parse(JSON.stringify(this.testData));
    testData.splice(1, 1);
    testData = testData.toString();
    for (let tag in matchingArr) {
      if (matchingArr[tag].includes(testData)) {
        this.resultData = {
          txt: require(`@/assets/img/result_txt_${tag}.png`),
          img: require(`@/assets/img/result_wine_${tag}.png`)
        };
        break;
      }
    }
    const that = this;
    // 定位信息
    const geolocation = new qq.maps.Geolocation();
    geolocation.getIpLocation(
      res => {
        console.log(res.city);
        that.axios
          .post(
            "http://wine.koyooo.com/phone/getStoreList.html",
            "city=" + res.city
          )
          .then(res => {
            if (res.code == 200) {
              that.shopList = res.data;
            }
          });
      },
      err => {
        console.log(err);
        that.$toast("定位失败！");
      }
    );
    // 初始化地址解析
  },
  methods: {
    showMap(data) {
      console.log(data);
      //调用地址解析类
      new qq.maps.Geocoder({
        complete: function(result) {
          console.log(result);
          let mapStr = `https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:${
            result.detail.location.lat
          },${result.detail.location.lng};title:${data.name};addr:${
            data.address
          }&key=FA6BZ-X4T3F-NMDJN-NEKC4-OWI6K-CMB5Q&referer=澳大利亚葡萄酒-H5`;
          self.location.href = mapStr;
        }
      }).getLocation(data.address);
    },
    openOnline() {
      self.location.href =
        "https://weixin.crvole.com.cn/index.html#/ActivityPage/australianwine";
    }
  }
};
</script>

<style lang="scss" scoped>
.foot_page {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background: #000;
  overflow-y: auto;
  .top_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    // background: rgba($color: #000000, $alpha: 0.6);
    .top_txt {
      letter-spacing: 1px;
      color: #ffffff;
      font-size: 40px;
      margin-top: 30px;
      margin-bottom: 30px;
    }
    .result_txt {
      height: 135px;
      margin: 0 auto 76px;
    }
    .result_btn {
      width: 295px;
    }
    .btn_box {
      padding: 0 34px;
      margin-top: 50px;
    }
    .share_img {
      height: 60px;
      margin-top: 35px;
      margin-bottom: 60px;
    }
    .shop_box {
      width: 100%;
      max-height: 70%;
      padding: 0 40px 20px;
      background: #fff;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      overflow-y: auto;
      .shop_title {
        color: rgba(13, 0, 0, 1);
        font-weight: bold;
        line-height: 50px;
        font-size: 40px;
        text-align: center;
        line-height: 100px;
      }
      .shop_list {
        width: 100%;
        height: 96px;
        margin-bottom: 20px;
        padding-left: 50px;
        padding-right: 50px;
        line-height: 80px;
        border: 5px solid #c03947;
      }
    }
  }
}
</style>
